import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { ICompanyMast } from "../../models/CompanyMast";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { Search } from "../../shared/Search";
import { ILogin, IPermissionProps } from "../../models/Login";
import { IModel } from "./TargetTemplate";
import { EmptyTarget } from "./EmptyTarget";
import { ITarget } from "./ITarget";
import { format } from "date-fns";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Filter, EmptyFilter, IFilterTarget } from "./Filter";
import { safeFormatDate } from "../../models/DateFormatMapper";

interface Iprops {
    setModal: (modal: IModel) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ITarget>, loading: boolean });
    const [sale, setSale] = useState<boolean>(false);
    const [rec, setRec] = useState<boolean>(false);
    const [saleData, setSaleData] = useState<ITarget[]>([])
    const [recData, setRecData] = useState<ITarget[]>([])
    const [filters, setFilters] = useState<IFilterTarget>(EmptyFilter);
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);
    const dt = useRef<any>(null);

    let _role: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _role.push(role.role_ID);
    });

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Target Table</h5>

        </div>
    );
    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyTarget });
    };

    const openEdit = (data: ITarget) => {
        props.setModal({ open: true, singleData: data });
    };

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2 gap-3">
                    {props.permissions.is_Create ? <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} /> : <></>}
                    {(_role.includes(1)) && <Button label="Sales" className="p-button-secondary mr-2" style={{ backgroundColor: sale ? '#339FFF' : '' }} onClick={() => { saleTable(); setSale(true) }} />}
                    {(_role.includes(1)) && <Button label="Recruiter" className="p-button-secondary mr-2" style={{ backgroundColor: rec ? '#339FFF' : '' }} onClick={() => { recruiterTable(); setRec(true) }} />}
                </div>
            </React.Fragment>
        );
    };
    const rightToolbarTemplate = () => {
        return <></>
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Tbl_Targets", "GET", null, `filter=${JSON.stringify(filters)}`, props.toast);
        if (response) {
            const data: ITarget[] = await response.json();
            const SalesData = data.filter((item) => item.user_Type === 'sales');
            setSaleData(SalesData)
            const RecuritersData = data.filter((item) => item.user_Type === "recruiter");
            setRecData(RecuritersData)
            if (_role.includes(1)) {
                if (sale === true) {
                    setTableData({ tableData: SalesData, loading: false });
                } else if (rec === true) {
                    setTableData({ tableData: RecuritersData, loading: false });
                } else {
                    setTableData({ tableData: SalesData, loading: false });
                    setSale(true);
                }
            } else {
                setTableData({ tableData: data, loading: false });
            }

        } else {
            setTableData({ tableData: tableData.tableData, loading: false });
        }
    }


    const Approve = async (data: ITarget) => {
        const response = await Fetch("Tbl_Targets/approve", "PUT", null, `target_Id=${data.target_Id}`, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Target Approved", life: 3000 });
            loadTableData();
        }
    }

    const Action = (rowData: ITarget) => {
        return (
            <>
                <Button className="p-button-sm my-1 bg-blue-500 mr-2" icon="pi pi-pencil" tooltip="Edit" onClick={() => openEdit(rowData)} type="button"></Button>
                {rowData.is_Approve !== true && <Button className="p-button-sm my-1 bg-green-500" icon="pi pi-check" tooltip="Approve" onClick={() => Approve(rowData)} type="button"></Button>}
                {/* {(rowData.is_Approve !== false || rowData.is_Approve !== null || rowData.is_Approve !== undefined) && <Button className="p-button-sm p-button-danger my-1" icon="pi pi-times" tooltip="Reject" type="button" onClick={() => setRejrctionOpen({ req_ID: rowData.req_ID, open: true })}></Button>} */}
            </>
        );
    }

    const rowClass = (data: ITarget) => {

        return {
            'bg-green-300 text-black': data.is_Approve === true ? true : false
        };
    }
    // className={`p-button-info mr-2 ${sale ? 'sales-clicked' : ''}`}

    useEffect(() => {
        loadTableData();
    }, [filters, props.reload]);

    const saleTable = () => {
        setRec(false)
        setTableData({ tableData: saleData, loading: false });
    }
    const recruiterTable = () => {
        setSale(false)
        setTableData({ tableData: recData, loading: false });
    }

    const DateFormat = loginObj?.date_Format
    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter filters={filters} setFilters={(filters: IFilterTarget) => setFilters(filters)} toast={props.toast} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll"
                value={tableData.tableData}
                emptyMessage="No Requirements found."
                header={header}
                loading={tableData.loading}
                rowClassName={rowClass}
            >
                <Column field="company_Name" header="Company Name" />
                <Column field="branch_Name" header="Branch Name" />
                <Column field="team_Name" header="Team Name" />
                <Column field="user_Name" header="Name" sortable />
                <Column field="reporting_Period" header="Reporting Period" body={(rowData) => <p>{rowData.reporting_Period === 1 ? "Monthly" : (rowData.reporting_Period === 2 ? "Quaterly" : (rowData.reporting_Period === 3 ? "Half Yearly" : (rowData.reporting_Period === 4 ? "Annualy" : "")))}</p>} />

                {(_role.includes(3) || _role.includes(4) || _role.includes(1)) && sale != true && <Column field="sub" header="SUB" body={(rowData) => <p>{rowData.sub === 0 ? "-" : rowData.sub}</p>} />}
                {(_role.includes(2) || _role.includes(5) || _role.includes(1)) && rec != true && <Column field="req" header="REQ" body={(rowData) => <p>{rowData.req === 0 ? "-" : rowData.req}</p>} />}
                <Column field="ecs" header="ECS" />
                <Column field="eci" header="ECI" />
                <Column field="po" header="PO" />
                {/* <Column field="created_At" header="Created At" body={(rowData) => <p>{rowData.created_At ? format(new Date(rowData.created_At), 'dd/MM/yyyy hh:mm a').toUpperCase().split(" ")[0] : ""}</p>} /> */}
                <Column field="created_At" header="Created At" sortable body={(rowData: any) => safeFormatDate(rowData.created_At, "dd/MM/yyyy", DateFormat, true)} />
                <Column field="updated_By_Name" header="Updated By" />
                {/* <Column field="updated_At" header="Updated At" body={(rowData) => <p>{rowData.updated_At ? format(new Date(rowData.updated_At), 'dd/MM/yyyy hh:mm a').toUpperCase().split(" ")[0] : ""}</p>} /> */}
                <Column field="updated_At" header="Updated At" body={(rowData: any) => safeFormatDate(rowData.updated_At, 'dd/MM/yyyy', DateFormat, true)} />
                <Column field="approve_By_Name" header="Approved By" />
                {/* <Column field="approve_Date" header="Approved At" body={(rowData) => <p>{rowData.approve_Date ? format(new Date(rowData.approve_Date), 'dd/MM/yyyy hh:mm a').toUpperCase().split(" ")[0] : ""}</p>} /> */}
                <Column field="approve_Date" header="Approved At" body={(rowData : any)  => safeFormatDate(rowData.approve_Date, 'dd/MM/yyyy', DateFormat, true) } />
                {props.permissions.is_Update && <Column header="Action" body={Action} />}
            </DataTable>
        </>
    );
}
